import canUseDom from "rc-util/es/Dom/canUseDom";
import { useEffect, useLayoutEffect } from 'react';

// It's safe to use `useLayoutEffect` but the warning is annoying
var useIsomorphicLayoutEffect = canUseDom() ? useLayoutEffect : useEffect;
export default useIsomorphicLayoutEffect;


//////////////////
// WEBPACK FOOTER
// ./node_modules/rc-motion/es/hooks/useIsomorphicLayoutEffect.js
// module id = 610
// module chunks = 0